import { env } from "../../../config/env";
import { apiClient } from "../../config";

import {
  PublicSettingsResponse,
  CompanySettings,
} from "../../interface/public.interface";

/**
 * ============================================
 * ⚙️ PUBLIC SETTINGS SERVICE
 * ============================================
 */

class SettingsService {
  /**
   * 🏢 GET SETTINGS
   */
  async getSettings(): Promise<CompanySettings> {
    const response = await apiClient.get<PublicSettingsResponse>(
      env.SETTINGS.PUBLIC
    );

    return response.data.data.settings;
  }
}

export const publicSettingsService = new SettingsService();